import { PATH } from 'constants/RoutesConstants';
import { SOCKET_TOPIC } from 'modules/sockets/constants';
import { subscribeOnPage } from 'modules/sockets/utils.middleware';

import { getSocketSubscription } from '../selectors/details';

export default function* contactListSocket() {
  // Initialize socket on page
  yield subscribeOnPage([PATH.CONTACT_LISTS_DETAILS], SOCKET_TOPIC.DETAILS, getSocketSubscription);
}
